import { IS_DEBUG } from '@/client/confs/app';
import { APP_I18N } from '@/client/confs/i18n-config';
import i18next from 'i18next';
import backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18next
  .use(backend)
  .use(initReactI18next)
  .init({
    // https://www.i18next.com/overview/configuration-options
    debug: IS_DEBUG,
    lng: APP_I18N.defaultLocale,
    fallbackLng: APP_I18N.defaultLocale,
    supportedLngs: APP_I18N.locales.map(item => item.lang),
    lowerCaseLng: true,
    load: 'currentOnly',
    defaultNS: 'translation',
    fallbackNS: 'translation',
    interpolation: { escapeValue: false },
    // https://github.com/i18next/i18next-http-backend
    backend: { loadPath: '/lang/{{lng}}/{{ns}}.json', queryStringParams: { v: APP_I18N.version } },
  });

/**
 * Pick a per-locale string from a {locale: text} map returned by the backend
 * (name_i18n / rule_i18n / title_i18n). Falls back to the English base field
 * when the map is missing or has no entry for the current locale.
 */
export function pickI18n(map: Record<string, string> | undefined | null, fallback: string): string {
  if (!map) return fallback;
  const lang = (i18next.language || '').toLowerCase();
  return map[lang] || map[lang.split('-')[0]] || fallback;
}

export default i18next;
